import React from 'react';

interface IEmptyDatatable {
  message: string
}

export const EmptyDatatable = (props: IEmptyDatatable) => {
  return <div style={{ padding: '24px', fontWeight: 'bolder' }}>{props.message}</div>;
};
